import { useMemo } from 'react'
import { format, addDays } from 'date-fns'
import useBootstrapData from '@/hooks/useBootstrapData'
import type { MultiHotelFormState } from '../../SearchForm/MultiHotelSearchForm/types'
import { getInitialState } from '../../SearchForm/MultiHotelSearchForm/utils'

const useMultiHotelFormInitialValues = () => {
  const {
    isMobile,
    webstats: { clientGUID: cguid }
  } = useBootstrapData()

  const initialValues: MultiHotelFormState = useMemo(() => {
    const startDate = format(new Date(), 'yyyyMMdd')
    const endDate = format(addDays(new Date(), 1), 'yyyyMMdd')

    const baseState = getInitialState(startDate, endDate, null)

    return {
      ...baseState,
      travelers: {
        adults: baseState.travelers.adults,
        children: baseState.travelers.children,
        childrenAges: baseState.travelers.childrenAges,
        rooms: baseState.travelers.rooms,
        lapInfants: 0
      }
    } as MultiHotelFormState
  }, [])

  return {
    initialValues,
    isMobile,
    cguid
  }
}

export default useMultiHotelFormInitialValues
